<template>
  <div class="body">
    <!-- 使用 TopNav 组件 -->
    <TopNav />

    <div class="page">
      <div class="img1"><img src="@/assets/代表工程/武汉天河机场.jpeg" alt="">
        <div class="img1title">武汉天河机场</div></div>
      <div class="mode">
        <div class="mode1">
          <div class="modetitle">
            <div class="gang"></div>
            <span>发展历程</span>
            <div class="gang"></div>
          </div>
          <div class="modepage">
            <div class="timeline">
              <div class="timeline-item">
                <div class="timeline-year">2013</div>
                <div class="timeline-content">
                  <div class="timeline-date-event">
                    <span class="timeline-date">1月10日</span>
                    <span class="timeline-event">公司成立：湖北江城子建材科技有限公司注册正式成立</span>
                  </div>
                </div>
              </div>
              <div class="timeline-item">
                <div class="timeline-year">2018</div>
                <div class="timeline-content">
                  <div class="timeline-date-event">
                    <span class="timeline-date">7月</span>
                    <span class="timeline-event">入选2018-2021年度湖北省交通投资集团有限公司建设项目材料供应商</span>
                  </div>
                </div>
              </div>
              <div class="timeline-item">
                <div class="timeline-year">2020</div>
                <div class="timeline-content">
                  <div class="timeline-date-event">
                    <span class="timeline-date">12月</span>
                    <span class="timeline-event">获得高新技术企业证书</span>
                  </div>
                </div>
              </div>
              <div class="timeline-item">
                <div class="timeline-year">2021</div>
                <div class="timeline-content">
                  <div class="timeline-date-event">
                    <span class="timeline-date">3月</span>
                    <span class="timeline-event">取得CRCC铁路产品认证证书</span>
                  </div>
                </div>
              </div>
              <div class="timeline-item">
                <div class="timeline-year">2021</div>
                <div class="timeline-content">
                  <div class="timeline-date-event">
                    <span class="timeline-date">6月</span>
                    <span class="timeline-event">入选2021-2024年度湖北省交通投资集团有限公司建设项目材料供应商</span>
                  </div>
                </div>
              </div>
              <div class="timeline-item">
                <div class="timeline-year">2021</div>
                <div class="timeline-content">
                  <div class="timeline-date-event">
                    <span class="timeline-date">9月26日</span>
                    <span class="timeline-event">注册成立湖北江城子建材科技（荆门）有限公司</span>
                  </div>
                </div>
              </div>
              <div class="timeline-item">
                <div class="timeline-year">2024</div>
                <div class="timeline-content">
                  <div class="timeline-date-event">
                    <span class="timeline-date">4月</span>
                    <span class="timeline-event">入选2024-2027年度湖北省交通投资集团有限公司建设项目材料供应商</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <FootIndex></FootIndex>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from '@/components/TopNav.vue' // 引入 TopNav 组件
import FootIndex from '@/components/FootIndex.vue'

export default {
  name: 'DevelopmentIndex',
  components: {
    TopNav, // 注册 TopNav 组件
    FootIndex
  }
}
</script>

<style lang="less" scoped>
.body {
  display: grid;
  grid-template-rows: 66px auto; /* 第一行是 nav 的高度，第二行是剩余空间 */
  height: 100vh;
}

.page{
  padding-top: 100px;
}

.img1 {
  width: 100%;
  height: 400px;
  min-width: 1000px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.img1 img{
  width: 100%;
  min-width: 1200px;
  object-fit: cover; /* 图片填充容器，保持比例 */
  object-position: center; /* 图片居中 */
  position: relative;
}

.img1title{
  position: absolute;
  bottom: 40px; /* 放置在底部 */
  left: 50%; /* 水平居中 */
  transform: translateX(-50%); /* 水平居中 */
  background-color: rgba(8, 105, 231, 0.558); /* 背景色 */
  color: white; /* 文字颜色 */
  padding: 4px 0px; /* 内边距 */
  border-radius: 5px; /* 圆角 */
  z-index: 1;
  width: 40%;
}

.modetitle {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px;
}

.modetitle span {
  font-size: 30px;
    padding-top: 0px;
    font-weight: bold;
    font-family: SimSun;
  color: #000;
  margin: 0 6px 0px 6px;
}

.gang {
  display: block;
  background: rgb(198, 198, 198);
  width: 1rem;
  height: 0.062rem;
  border-radius: inherit;
}

.modepage {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-top: 0.002rem solid rgb(220, 220, 220);
  padding: 20px;
}

.timeline {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
}

.timeline::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: #e4e4e4;
  left: 20%;
  margin-left: 31px;
}

.timeline-item {
  display: flex;
  margin-bottom: 60px; /* 增加事件之间的间隔 */
  position: relative;
}

.timeline-year {
  width: 20%;
  text-align: right;
  padding-right: 60px;
  font-size: 20px;
  font-weight: bold;
  color: #004da0;
  position: relative;
}

.timeline-year::before {
  content: '';
  position: absolute;
  width: 12px;
  height: 12px;
  background-color: #004da0;
  border-radius: 50%;
  right: -10px; /* 调整原点位置，使其在时间线上 */
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}

.timeline-content {
  width: 80%;
  padding-left: 100px;
}

.timeline-date-event {
  display: flex;
  align-items: center;
}

.timeline-date {
  font-size: 18px;
  color: #333;
  margin-right: 10px;
}

.timeline-event {
  font-size: 18px;
  color: #555;
}
</style>
